import { Select } from 'antd';
import { debounce, isObject, isString } from 'lodash';
import React, { BaseSyntheticEvent, useCallback } from 'react';
import styled from 'styled-components';

import { ICommonInputProps, ISelectAsyncProps } from './types';

const { Option } = Select;

const SelectStyled = styled(Select)`
  width: 100%;
  & .ant-select-selector {
    width: 100%;
  }
  .ant-select-clear {
    opacity: 1;
  }
`;

const SelectInputAsync: React.FC<ICommonInputProps & { selectAsyncProps: ISelectAsyncProps }> = ({
  disabled,
  placeholder,
  defaultValue,
  inputSettings,
  inputClassName,
  onChange,
  onBlur,
  value,
  selectAsyncProps,
  inputOptions,
}) => {
  const { fetchNextPage, meta, fetchByQuery, loading } = selectAsyncProps;

  const generateSelectOptions = useCallback(
    (opt) => (
      <Option
        style={{ display: opt.value === undefined ? 'none' : undefined }}
        key={opt.value}
        value={opt.value}
        disabled={opt.disabled}>
        {opt.label}
      </Option>
    ),
    [value],
  );

  const onSearch = useCallback(
    debounce((v: string) => {
      fetchByQuery?.(v);
    }, 250),
    [],
  );

  const onScroll = (e: BaseSyntheticEvent) => {
    const { target } = e;
    if (target.scrollTop + target.offsetHeight >= target.scrollHeight - 10) {
      fetchNextPage?.();
    }
  };

  const loadMoreOption =
    meta?.hasNextPage || loading ? [{ value: 'placeholder-value', label: <div>Loading...</div>, disabled: true }] : [];

  return (
    <SelectStyled
      disabled={disabled}
      placeholder={placeholder || 'Select...'}
      defaultValue={defaultValue === undefined ? undefined : defaultValue}
      value={value === undefined ? undefined : value}
      mode={inputSettings?.mode}
      filterOption={(input, option) => {
        if (option?.value === 'placeholder-value') return false;
        return (
          (isString(option?.props.children) && option?.props.children.toLowerCase().includes(input.toLowerCase())) ||
          (!isObject(option?.value) && option?.value?.toString().toLowerCase().includes(input.toLowerCase()))
        );
      }}
      showSearch
      onBlur={onBlur}
      onSearch={onSearch}
      allowClear
      showArrow={false}
      onPopupScroll={onScroll}
      className={`select-input ${inputClassName}`}
      onClear={() => {
        onSearch('');
      }}
      onChange={onChange}>
      {inputOptions && [...inputOptions, ...loadMoreOption].map(generateSelectOptions)}
    </SelectStyled>
  );
};

export default React.memo(SelectInputAsync);
